import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import ExportCSV from "../../../utils/ExportCSV/ExportCSV";
import { statisticAdminContext } from "../../../context/Admin/StatisticAdminContext/StatisticAdminContext";
import { DateInput } from "react-hichestan-datetimepicker";
import {
  convertDataToCSV,
  dialogContainerStyle,
  numberSeparate,
} from "../../../utils";

const StatisticAdmin = () => {
  const {
    statistics,
    mobile_verified,
    setMobile_verified,
    dateType,
    setDateType,
    isNot_in,
    setIsNot_in,
    table,
    setTable,
    fromDate,
    setFromDate,
    limit,
    setLimit,
    toDate,
    setToDate,
    services,
    order_status,
    setOrder_status,
    employers,
    employer,
    setEmployer,
    handleGetStatistics,
    handleGetServices,
    handleGetEmployers,
  } = useContext(statisticAdminContext);

  useEffect(() => {
    handleGetServices();
    handleGetEmployers();
  }, []);

  const copyTable = () => {
    const elTable = document.querySelector("#StatisticsTable");
    let range, sel;

    // Ensure that range and selection are supported by the browsers
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      // unselect any element in the page
      sel.removeAllRanges();
      try {
        range.selectNodeContents(elTable);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(elTable);
        sel.addRange(range);
      }

      document.execCommand("copy");
    }

    sel.removeAllRanges();
  };

  return (
    <>
      <SiteTitle title="آمارگیری" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "آمارگیری", type: "a" },
        ]}
        title="آمارگیری"
      />

      <CardLayout>
        <form onSubmit={handleGetStatistics} autoComplete="off">
          <div>
            <h5>بازه زمانی</h5>
            <div className="d-flex justify-content-between">
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="dateType0"
                  name="dateType"
                  className="custom-control-input"
                  value="0"
                  checked={dateType === 0}
                  onChange={(e) => setDateType(Number(e.target.value))}
                />
                <label className="custom-control-label" for="dateType0">
                  همه
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="dateType1"
                  name="dateType"
                  className="custom-control-input"
                  value="1"
                  checked={dateType === 1}
                  onChange={(e) => setDateType(Number(e.target.value))}
                />
                <label className="custom-control-label" for="dateType1">
                  از
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="dateType2"
                  name="dateType"
                  className="custom-control-input"
                  value="2"
                  checked={dateType === 2}
                  onChange={(e) => setDateType(Number(e.target.value))}
                />
                <label className="custom-control-label" for="dateType2">
                  بازه
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="dateType3"
                  name="dateType"
                  className="custom-control-input"
                  value="3"
                  checked={dateType === 3}
                  onChange={(e) => setDateType(Number(e.target.value))}
                />
                <label className="custom-control-label" for="dateType3">
                  روز اخیر
                </label>
              </div>
            </div>
            <div className="row mt-3">
              {dateType === 1 ? (
                <>
                  <div className="col-12 mb-2">
                    <DateInput
                      id="fromDate"
                      value={fromDate}
                      className="form-control"
                      name="fromDate"
                      onChange={(e) => setFromDate(e.target.value)}
                      autoOk="false"
                      placeholder="از تاریخ"
                      dialogContainerStyle={dialogContainerStyle}
                    />
                  </div>
                </>
              ) : dateType === 2 ? (
                <>
                  <div className="col-12 col-md-6 mb-2">
                    <DateInput
                      id="fromDate"
                      value={fromDate}
                      className="form-control"
                      name="fromDate"
                      onChange={(e) => setFromDate(e.target.value)}
                      autoOk="false"
                      placeholder="از تاریخ"
                      dialogContainerStyle={dialogContainerStyle}
                    />
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <DateInput
                      id="toDate"
                      value={toDate}
                      className="form-control"
                      name="toDate"
                      onChange={(e) => setToDate(e.target.value)}
                      autoOk="false"
                      placeholder="تا تاریخ"
                      dialogContainerStyle={dialogContainerStyle}
                    />
                  </div>
                </>
              ) : dateType === 3 ? (
                <>
                  <input
                    type="number"
                    className="form-control"
                    value={limit}
                    min="0"
                    onChange={(e) =>
                      e.target.value < 0
                        ? setLimit(0)
                        : setLimit(parseInt(e.target.value))
                    }
                  />
                </>
              ) : null}
            </div>
          </div>
          <hr />
          <div>
            <h5>سازمان</h5>
            <select
              className="form-control"
              name="employer"
              onChange={(e) =>
                setEmployer(e.target.value ? e.target.value : null)
              }
            >
              <option selected value="">
                همه
              </option>
              <option key="null" value="null">
                فقط عادی
              </option>
              {employers?.map((_value, index) => (
                <option
                  key={index}
                  selected={_value?.id === employer}
                  value={_value?.id}
                >
                  {_value?.name}
                </option>
              ))}
            </select>
          </div>
          <hr />
          <div>
            <h5>جدول</h5>
            <div className="row justify-content-between align-items-center">
              <div className="col">
                <select
                  className="form-control"
                  name="type"
                  onChange={(e) => setTable(Number(e.target.value))}
                >
                  {services?.map((_value, index) => (
                    <option
                      key={index}
                      selected={index === table}
                      value={index}
                    >
                      {_value.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-auto custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="isNot_in"
                  checked={isNot_in}
                  onChange={(e) => setIsNot_in(e.target.checked)}
                />
                <label className="custom-control-label" for="isNot_in">
                  عدم وجود
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <h5>وضعیت تاییدیه موبایل</h5>
            <div className="d-flex justify-content-between">
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="mobile_verified0"
                  name="mobile_verified"
                  className="custom-control-input"
                  value="0"
                  checked={mobile_verified === "0"}
                  onChange={(e) => setMobile_verified(e.target.value)}
                />
                <label className="custom-control-label" for="mobile_verified0">
                  مهم نیست
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="mobile_verifiedTrue"
                  name="mobile_verified"
                  className="custom-control-input"
                  value="true"
                  checked={mobile_verified === "true"}
                  onChange={(e) => setMobile_verified(e.target.value)}
                />
                <label
                  className="custom-control-label"
                  for="mobile_verifiedTrue"
                >
                  تاییده شده ها
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="mobile_verifiedFalse"
                  name="mobile_verified"
                  className="custom-control-input"
                  value="false"
                  checked={mobile_verified === "false"}
                  onChange={(e) => setMobile_verified(e.target.value)}
                />
                <label
                  className="custom-control-label"
                  for="mobile_verifiedFalse"
                >
                  تاییده نشده ها
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <h5>وضعیت تاییدیه سفارش</h5>
            <div className="d-flex justify-content-between">
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="order_status0"
                  name="order_status"
                  className="custom-control-input"
                  value="false"
                  checked={order_status === false}
                  onChange={(e) => setOrder_status(false)}
                />
                <label className="custom-control-label" for="order_status0">
                  هر سفارشی
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="order_status1"
                  name="order_status"
                  className="custom-control-input"
                  value="true"
                  checked={order_status === true}
                  onChange={(e) => setOrder_status(true)}
                />
                <label className="custom-control-label" for="order_status1">
                  سفارشات موفق
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <button type="submit" className="btn btn-primary px-5">
                جستجو
              </button>
            </div>
            {!isEmpty(statistics) && (
              <div>
                <button
                  className="btn btn-outline-primary mr-3"
                  onClick={copyTable}
                >
                  <i className="fas fa-copy" /> کپی در کلیپ بورد
                </button>
                <ExportCSV
                  csvData={() => convertDataToCSV(statistics, "statistics")}
                />
              </div>
            )}
          </div>
        </form>
        <br />
        <br />
        {isEmpty(statistics) ? (
          <EmptyData />
        ) : (
          <Table responsive hover borderless striped id="StatisticsTable">
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>نام</th>
                <th>نام خانوادگی</th>
                <th>شماره موبایل</th>
                <th>تعداد سفارشات</th>
              </tr>
            </thead>
            <tbody>
              {statistics.map((_item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{_item.user.first_name}</td>
                  <td>{_item.user.last_name}</td>
                  <td>{_item.user.mobile}</td>
                  <td>{numberSeparate(_item.user.order_count.all)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardLayout>
    </>
  );
};

export default StatisticAdmin;
